import { render } from "./VPushNotificationPrompt.vue?vue&type=template&id=3aee5435&ts=true"
import script from "./VPushNotificationPrompt.vue?vue&type=script&lang=ts"
export * from "./VPushNotificationPrompt.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__